import React from "react";
import defaultImage from "../../../assets/default.png";

interface Props {
    members: any[];
    showFamily: boolean;
    setShowFamily: (val: boolean) => void;
}

const FamilyList: React.FC<Props> = ({
    members,
    showFamily,
    setShowFamily
}) => {
    return (
        <div className="event-container">
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "14px",
                    cursor: "pointer"
                }}
                onClick={() => setShowFamily(!showFamily)}
            >
                <h3 style={{ margin: 0 }}>
                    <i className="fa-solid fa-users"></i> Family Group
                </h3>
                <i
                    className={`fa-solid ${showFamily ? "fa-chevron-up" : "fa-chevron-down"
                        }`}
                />
            </div>
            {showFamily &&
                members.map((member, index) => (
                    <div
                        key={member.id ?? index}
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            background: "#fff",
                            border: "1px solid #e5e5e5",
                            borderRadius: "12px",
                            padding: "12px",
                            marginBottom: "12px",
                            boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                        }}
                    >
                        <div style={{ display: "flex", gap: "12px" }}>
                            <img
                                src={
                                    member.imageUrl?.trim()
                                        ? member.imageUrl
                                        : defaultImage
                                }
                                onError={(e) =>
                                ((e.currentTarget as HTMLImageElement).src =
                                    defaultImage)
                                }
                                style={{
                                    width: "55px",
                                    height: "55px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                }}
                            />
                            <div>
                                <h4 style={{ margin: 0 }}>
                                    {member.name}
                                </h4>
                                <p style={{ margin: "4px 0", color: "#777" }}>
                                    {member.occupation || member.relation}
                                </p>
                                <p style={{ margin: 0, fontWeight: 600 }}>
                                    Phone: {member.phone || "N/A"}
                                </p>
                            </div>
                        </div>
                        <span
                            style={{
                                background: "var(--colorPrimaryDark)",
                                color: "#fff",
                                padding: "6px 12px",
                                borderRadius: "8px",
                                fontSize: "12px",
                                fontWeight: 600,
                            }}
                        >
                            {member.relation || "Member"}
                        </span>
                    </div>
                ))}
        </div>
    );
};

export default FamilyList;